import { render, staticRenderFns } from "./Modal_AFAS_3_Monthly.vue?vue&type=template&id=3dc5efc4&scoped=true&"
import script from "./Modal_AFAS_3_Monthly.vue?vue&type=script&lang=js&"
export * from "./Modal_AFAS_3_Monthly.vue?vue&type=script&lang=js&"
import style0 from "./Modal_AFAS_3_Monthly.vue?vue&type=style&index=0&id=3dc5efc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc5efc4",
  null
  
)

export default component.exports